import React, { FC } from 'react';
import map from 'lodash/map';
import { Box, styled } from '@mui/material';

const Container = styled(Box)(() => ({
  direction: 'rtl',
  overflow: 'hidden',
  whiteSpace: 'nowrap'
}));
const Wrapper = styled(Box)(() => ({
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  display: 'inline-block',
  animation: 'slide-infinite 10s linear infinite'
}));
const Items = styled(Box)(() => ({
  overflow: 'hidden',
  whiteSpace: 'nowrap'
}));

type InfiniteItemsProps = {
  duration?: number;
  children: JSX.Element[];
};

const InfiniteItems: FC<InfiniteItemsProps> = ({
  children,
  duration = 10000
}) => {
  const items = React.useMemo(() => {
    if (children.length > 0) {
      return map(children, (ch, i) => (
        <Box key={i} sx={{ display: 'inline-block' }}>
          {ch}
        </Box>
      ));
    }
    return [];
  }, []);

  return (
    <Container>
      <Wrapper style={{ animationDuration: `${duration}ms` }}>
        <Box sx={{ display: 'inline-block' }}>
          <Items>{items}</Items>
        </Box>
        <Box sx={{ display: 'inline-block' }}>
          <Items>{items}</Items>
        </Box>
      </Wrapper>
    </Container>
  );
};

export default InfiniteItems;
